export const LOCAL_STORAGE_ACCESS_TOKEN = 'access_token';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refresh_token';
export const LOCAL_STORAGE_USER_ID = 'user_id';
export const LOCAL_STORAGE_WAX_ACCOUNT = 'wax_account';
export const LOCAL_STORAGE_FLOW_ACCOUNT = 'flow_account';
export const LOCAL_STORAGE_EMAIL_TO_JOIN = 'email_to_join';
